import React from "react";
import { GALLERY } from "@/lib/content";

export default function Gallery() {
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] text-[#7a8582] flex items-center">
                            <span className="gdc-divider" />
                            Inside the clinic
                        </div>
                        <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight text-[#1a1d1c] max-w-2xl">
                            A studio designed to feel{" "}
                            <span className="italic text-[#114b5f]">
                                nothing like a clinic.
                            </span>
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <img
                        src={GALLERY[0]}
                        alt="Reception"
                        className="col-span-12 md:col-span-8 h-72 md:h-[420px] w-full object-cover rounded-3xl"
                    />
                    <img
                        src={GALLERY[1]}
                        alt="Chair"
                        className="col-span-6 md:col-span-4 h-72 md:h-[420px] w-full object-cover rounded-3xl"
                    />
                    <img
                        src={GALLERY[2]}
                        alt="Equipment"
                        className="col-span-6 md:col-span-4 h-64 md:h-80 w-full object-cover rounded-3xl"
                    />
                    <img
                        src={GALLERY[3]}
                        alt="Treatment"
                        className="col-span-12 md:col-span-8 h-64 md:h-80 w-full object-cover rounded-3xl"
                    />
                </div>
            </div>
        </section>
    );
}
